(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var cartForm = document.getElementById('cart-form');
  if (!cartForm) return;

  // Quantity controls
  var qtyButtons = document.querySelectorAll('.qty-btn');
  qtyButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      var line = this.dataset.line;
      var input = document.querySelector('input[data-line="' + line + '"]');
      var currentQty = parseInt(input.value);

      if (this.classList.contains('minus')) {
        if (currentQty > 0) {
          input.value = currentQty - 1;
        }
      } else if (this.classList.contains('plus')) {
        input.value = currentQty + 1;
      }

      // Auto-submit form to update cart
      updateCart();
    });
  });

  // Update cart function
  function updateCart() {
    var formData = new FormData(cartForm);

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      // Reload page to show updated cart
      window.location.reload();
    })
    .catch(function(error) {
      console.error('Error updating cart:', error);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const productsGrid = document.querySelector('[data-products-grid]');
  const skeletonCards = document.querySelectorAll('.product-card-skeleton');

  // Listen for category changes from tabs
  document.addEventListener('category:changed', function(event) {
    const { category } = event.detail;

    if (category && category !== 'all') {
      // Show loading skeletons
      showLoadingSkeletons();

      // Filter products by category (this would typically involve an AJAX call)
      // For now, we'll simulate the loading
      setTimeout(() => {
        hideLoadingSkeletons();
        // In a real implementation, you'd update the grid with filtered products
      }, 800);
    }
  });

  function showLoadingSkeletons() {
    const productCards = productsGrid.querySelectorAll('.product-card:not(.product-card-skeleton)');
    productCards.forEach(card => {
      card.style.opacity = '0.3';
    });

    skeletonCards.forEach(skeleton => {
      skeleton.classList.remove('hidden');
    });
  }

  function hideLoadingSkeletons() {
    const productCards = productsGrid.querySelectorAll('.product-card:not(.product-card-skeleton)');
    productCards.forEach(card => {
      card.style.opacity = '1';
    });

    skeletonCards.forEach(skeleton => {
      skeleton.classList.add('hidden');
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-reels"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const reelCards = document.querySelectorAll('.reel-card');
  const videos = [];
  let currentlyPlaying = null;

  // Collect all videos
  reelCards.forEach(card => {
    const video = card.querySelector('video');
    if (video) {
      videos.push(video);

      // Hide poster overlay when video starts playing
      video.addEventListener('play', function() {
        this.classList.add('playing');
      });

      video.addEventListener('pause', function() {
        this.classList.remove('playing');
      });
    }
  });

  // Intersection Observer for auto-play on scroll
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.7 // 70% visible
  };

  const handleIntersection = (entries) => {
    entries.forEach(entry => {
      const video = entry.target.querySelector('video');

      if (!video) return;

      if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
        // Stop any currently playing video
        if (currentlyPlaying && currentlyPlaying !== video) {
          currentlyPlaying.pause();
          currentlyPlaying.currentTime = 0;
          currentlyPlaying.classList.remove('playing');
        }

        // Play this video
        video.play().catch(err => {
          console.log('Auto-play prevented:', err);
        });
        currentlyPlaying = video;
      } else {
        // Pause and reset when scrolling away
        if (video === currentlyPlaying) {
          video.pause();
          video.currentTime = 0;
          video.classList.remove('playing');
          currentlyPlaying = null;
        }
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersection, observerOptions);

  // Observe all reel cards
  reelCards.forEach(card => {
    observer.observe(card);
  });

  // Optional: Click to pause/play
  reelCards.forEach(card => {
    card.addEventListener('click', (e) => {
      const video = card.querySelector('video');
      if (video) {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      }
    });
  });

  // Desktop Carousel Navigation
  const reelsContainer = document.querySelector('.reels-container');
  const reelsPrevBtn = document.querySelector('.reels-prev');
  const reelsNextBtn = document.querySelector('.reels-next');

  if (reelsContainer && reelsPrevBtn && reelsNextBtn) {
    let currentReelIndex = 0;
    const reelWidth = 300; // 300px card width
    const gap = 4; // 4px gap between cards
    let visibleReels = 4;
    let maxReelIndex = 0;

    function calculateVisibleReels() {
      // Calculate how many reels actually fit based on wrapper's visible width
      const wrapperWidth = reelsContainer.parentElement.offsetWidth;
      // Correct formula: accounts for gap only appearing between items, not after last item
      visibleReels = Math.floor((wrapperWidth + gap) / (reelWidth + gap));
      maxReelIndex = Math.max(0, window.instagramReelsBlocksSize - visibleReels);
    }

    function updateReelsCarousel() {
      const translateX = -(currentReelIndex * (reelWidth + gap));
      reelsContainer.style.transform = `translateX(${translateX}px)`;

      // Update button states
      reelsPrevBtn.style.opacity = currentReelIndex === 0 ? '0.5' : '1';
      reelsPrevBtn.style.cursor = currentReelIndex === 0 ? 'not-allowed' : 'pointer';
      reelsNextBtn.style.opacity = currentReelIndex >= maxReelIndex ? '0.5' : '1';
      reelsNextBtn.style.cursor = currentReelIndex >= maxReelIndex ? 'not-allowed' : 'pointer';
    }

    reelsPrevBtn.addEventListener('click', function() {
      if (currentReelIndex > 0) {
        currentReelIndex--;
        updateReelsCarousel();
      }
    });

    reelsNextBtn.addEventListener('click', function() {
      if (currentReelIndex < maxReelIndex) {
        currentReelIndex++;
        updateReelsCarousel();
      }
    });

    // Recalculate on window resize
    let resizeTimeout;
    const resizeHandler = function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        calculateVisibleReels();

        // Adjust current index if it's now beyond the new max
        if (currentReelIndex > maxReelIndex) {
          currentReelIndex = maxReelIndex;
        }

        updateReelsCarousel();
      }, 150);
    };

    // Clean up any previous resize listener to prevent memory leaks in Shopify Theme Editor
    if (reelsContainer.resizeController) {
      reelsContainer.resizeController.abort();
    }
    const controller = new AbortController();
    reelsContainer.resizeController = controller;

    window.addEventListener('resize', resizeHandler, { signal: controller.signal });

    // Initialize
    calculateVisibleReels();
    updateReelsCarousel();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-destinations"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.destinations-grid');
  const prevBtn = document.querySelector('.carousel-prev');
  const nextBtn = document.querySelector('.carousel-next');
  const cards = document.querySelectorAll('.new-destination-card-wrapper');

  if (!container || !prevBtn || !nextBtn || cards.length === 0) return;

  let currentIndex = 0;
  let scrollStep = 0;
  const visibleCards = 3; // Desktop shows 3 cards based on CSS lg:w-[calc(33.333%-0.67rem)]
  const totalCards = cards.length;
  const maxIndex = Math.max(0, totalCards - visibleCards);

  function calculateScrollStep() {
    if (cards.length > 1) {
      const containerStyle = window.getComputedStyle(container);
      const containerGap = parseFloat(containerStyle.gap);

      // Scroll distance = card width + gap
      scrollStep = cards[0].offsetWidth + (isNaN(containerGap) ? 0 : containerGap);
    } else {
      scrollStep = cards[0].offsetWidth;
    }
  }

  function updateCarousel() {
    const translateX = -(currentIndex * scrollStep);
    container.style.transform = `translateX(${translateX}px)`;

    // Update button states and accessibility
    prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
    prevBtn.disabled = currentIndex === 0;
    nextBtn.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
    nextBtn.disabled = currentIndex >= maxIndex;
  }

  prevBtn.addEventListener('click', function() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  nextBtn.addEventListener('click', function() {
    if (currentIndex < maxIndex) {
      currentIndex++;
      updateCarousel();
    }
  });

  // Initial calculation and setup
  calculateScrollStep();
  updateCarousel();

  // Recalculate on window resize to handle responsive changes
  window.addEventListener('resize', calculateScrollStep);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-categories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const categoryCards = document.querySelectorAll('.category-card');
  
  categoryCards.forEach(card => {
    // Add click tracking and analytics
    card.addEventListener('click', function(event) {
      // Only track if not clicking directly on the button
      if (!event.target.closest('a')) {
        const categoryTitle = card.querySelector('h3').textContent;
        const categoryUrl = card.querySelector('a').href;
        
        // Analytics tracking (if you have analytics setup)
        if (typeof gtag !== 'undefined') {
          gtag('event', 'category_card_click', {
            'category_name': categoryTitle,
            'category_url': categoryUrl
          });
        }
      }
    });
    
    // Add keyboard navigation
    const button = card.querySelector('a');
    card.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        button.click();
      }
    });
  });
  
  // Intersection Observer for animation on scroll
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.1 });
    
    categoryCards.forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(card);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const testimonialCards = document.querySelectorAll('.testimonial-card');
  
  // Intersection Observer for staggered animation
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, index * 100); // Stagger animation
        }
      });
    }, { threshold: 0.1 });
    
    testimonialCards.forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(30px)';
      card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(card);
    });
  }
  
});

  } catch(e) { console.error(e); }
})();
})();
